import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { NavLink } from "react-router-dom";
import "./Styles.css";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { FaChevronLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { searchByHeader } from "../Redux/authAction";
import api from '../config/api';

const FixedHeader = (props) => {
  const dispatch = useDispatch();

  const [state, setState] = useState(true);
  const apiData = props.apiData;

  //---------------------------------

  const [apiData2, setApiData2] = useState({
    title: [
      'Promotion Maker',
      'Resume Maker',
      'Employee Certificates',
      'Wedding Cards',
      'Birthday Cards',
      'Logo Maker',
      'Cover Letter',
    ]
  });

  //---------------------------------

  const selectedCategory = props.selectedCategory;
  const setSelectedCategory = props.setSelectedCategory;
  const setMySaveTemplates = props.setMySaveTemplates;
  const mySaveTemplates = props.mySaveTemplates;
  const setShow = props.setShow;
  const packageId = useSelector((state) => state.authReducer.packageid);
  const userID = useSelector((state) => state.authReducer.uid);
  const search = useSelector((state) => state.authReducer.search);
  const userName = useSelector((state) => state.authReducer.name);
  const emails = useSelector((state) => state.authReducer.email);
  const [packageSub, setpackagesub] = useState('');
  const [packages, setPackages] = useState('');
  const [packagetitle,setpackagetitle] = useState('');


  const fetchPackages = async () => {
    try {
      const response = await fetch(api.getUrl(api.ENDPOINTS.GET_PACKAGES));
      if (!response.ok) {
        throw new Error('Failed to fetch packages');
      }
      const data = await response.json();
      console.log("all packages",data);
      setPackages(data);
  
      // Compare packageId with fetched packages' id and set packagetitle
      const matchedPackage = data.find((pkg) => pkg.id == packageId); // Assuming package has an id field
      if (matchedPackage) {
        setpackagetitle(matchedPackage.title); // Assuming the title field exists
      }
      else{
        if(packageId==6 ){
        setpackagetitle("Business Plan expired");
      }
      if(packageId ==7){
        setpackagetitle("Premium Plan Expired")
      }
    }
  
    } catch (error) {
      console.error('Error fetching packages:', error.message);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);



  const handleClickTitle = (title) => {
    dispatch(searchByHeader(false));
    setSelectedCategory({
      title: title,
      icons: apiData.icons[apiData.title.indexOf(title)],
    });
    setShow(false);
  };
  const handleGetUserTemplates = () => {
    axios
      .post(api.getUrl(api.ENDPOINTS.GET_USER_TEMPLATES), {
        edited_by: userID,
      })
      .then((response) => {
        console.log("User templates:", response);
        setMySaveTemplates(response.data);
        setShow(true);
      })
      .catch((error) => {
        // Handle error
        console.error("Error fetching user templates:", error);
      });
  };

  return (
    <div style={{ color: "black" }}>
      <div
        className={`bg-white rounded-lg ml-1 fixed transition-all w-[280px] z-30 duration-700 shadow-lg`}
        style={{ height: "calc(100vh - 80px)", marginTop: "70px" }}
      >
        <div className="flex flex-col gap-2 items-center w-[250px] bg-[#F8F8F8] p-4 ml-[15px] mt-[18px] border-1 rounded-xl overflow-hidden">
          <Avatar alt="Remy Sharp"  src={selectedCategory.icons} />
          <div>
            <p className="text-[15px] text-[#262b33] font-[500]">Id: {`${userName}`}</p>
            <p className="text-[13px] font-[400] text-[#2b2b2b] -mt-1 pt-1" style={{fontFamily:"poppins"}}>Email: {`${emails}`}</p>
            {(packagetitle)?(<>
              <p className="text-[13px] font-[400] text-[#2b2b2b] -mt-1 pt-1" style={{fontFamily:"poppins"}}>Package: {`${packagetitle}`}</p>
            </>):(<>
            
            </>)}
           
          </div>
        </div>

        <div className="menu">
          {/* <NavLink to={"/"} className="home mt-6 focus:outline-none">
            <div
              className="focus:outline-none"
              style={{
                color: "#262b33",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              {" "}
              <FaChevronLeft style={{ color: "#262b33" }} /> <span className="" style={{ fontFamily:"poppins", fontWeight:"600"}}>Home</span>
            </div>
          </NavLink> */}
          <button
            className="home focus:outline-none w-full"
            onClick={handleGetUserTemplates}
          >
            {" "}
            <div
              style={{
                color: "#262b33",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <FaArrowRight />
              <span className="text-gray-700" style={{ fontFamily:"poppins", fontWeight:"600"}}>Recently</span>
            </div>
          </button>

          <p
            className="text-[16px] pl-5 pr-5 font-[700] text-gray-700 mb-3"
            style={{ fontFamily: "poppins" }}
          >
            {" "}
            Templates Categories
          </p>
          <ul >
            {apiData2.title &&
              apiData2.title.map((title, index) => (
                <div className="temp" key={index}>
                  <li
                    className="text-[16px] hover:text-[14px] hover:text-purple-600 flex text-gray-700 hover:text-black font-[500] pl-5 pr-2 pt-[10px] pb-[6px] justify-between items-center hover:justify-start  cursor-pointer hover:bg-white transition-transform transform hover:scale-110"
                    style={{ fontFamily: "Poppins, sans-serif", letterSpacing: "0.8px" }}
                    onClick={() => handleClickTitle(title)}
                  >
                    <img src={`/herosection/${title}.png`} className="w-[20px] mr-3 image-purple" alt="" />
                    {title}
                    {/* <KeyboardArrowRightIcon className="arrow-icon" /> */}
                  </li>
                </div>
              ))}
          </ul>

        </div>
      </div>
    </div>
  );
};

export default FixedHeader;
